<!-- Market Card with Header and player bets-->
@if (marketsGroup && marketsLength()) {
    <div class="container-inner-content player-bets" data-crlat="containerInnerContent.table">
        @if (!isDesktop) {
            <div class="background-header" [ngClass]="[isCoral ? 'players-markets-header-coral' : 'players-markets-header-lads']"></div>
        }
        <div class="players">
            <div
                class="players-header"
                [ngClass]="{
                    'players-header-coral': isCoral,
                    'players-header-lads': !isCoral,
                    'players-header-coral-desktop': isCoral && isDesktop,
                    'players-header-lads-desktop': !isCoral && isDesktop,
                    'player-header-desktop': isDesktop,
                }"
                data-crlat="oddsLeft">
                <span [textContent]="marketsGroup.headerLabel" data-crlat="oddsHeader"></span>
                @if (isDesktop && isPrevAvailablePB) {
                    <div class="prev" (click)="previous()">
                        <svg [ngClass]="{ 'lads-svg': !isCoral }">
                            <use xlink:href="#prev-arrow"></use>
                        </svg>
                    </div>
                }
            </div>
            <div class="players-names">
                @for (market of selectedMarkets(periodIndex); let i = $index; track i) {
                    <strong
                        class="players-names-item"
                        [ngClass]="{
                            'players-names-item-coral': isCoral,
                            'players-names-item-lads': !isCoral,
                            'players-names-item-lads-desktop': isDesktop && !isCoral,
                        }"
                        data-crlat="oddsNames">
                        <span [textContent]="market.name"> </span>
                    </strong>
                }
            </div>
        </div>
        <div class="player-bets-odds" [ngClass]="{ 'player-bets-odds-desktop': isDesktop }" id="{{ marketsGroup.localeName }}">
            <div
                class="player-markets-header odds-card-header"
                [ngClass]="{
                    'players-markets-header-coral': isCoral,
                    'players-markets-header-lads': !isCoral,
                    'players-markets-header-lads-desktop': isDesktop && !isCoral,
                }">
                @for (header of removeUnusedMarketNames(periodIndex); let i = $index; track i) {
                    <span class="odds-header-col" [textContent]="header.name" data-crlat="oddsHeader"></span>
                }
            </div>
            <div class="player-market-odds">
                @for (market of selectedMarkets(periodIndex); let i = $index; track i) {
                    <div class="player-market-odds-item">
                        @for (outcome of getMarketOutcomes(market, periodIndex); let i = $index; track trackById(i, outcome)) {
                            <div class="odds-btn-wrapper">
                                @if (!outcome.fakeOutcome) {
                                    <price-odds-button [event]="eventEntity" [market]="market" [outcome]="outcome" [isPb]="true"> </price-odds-button>
                                }
                                @if (outcome.fakeOutcome) {
                                    <button disabled class="btn-bet">-</button>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
        @if (isDesktop && ((!isLoadedPB && isNextavailable('outer')) || (isLoadedPB && isNextAvailableOuter))) {
            <div
                class="next"
                [ngClass]="{
                    'players-markets-header-coral': isCoral,
                    'players-markets-header-lads': !isCoral,
                    'players-markets-header-lads-desktop': isDesktop && !isCoral,
                }"
                (click)="next()">
                @if (isNextavailableInner) {
                    <svg [ngClass]="{ 'lads-svg': !isCoral }">
                        <use xlink:href="#next-arrow"></use>
                    </svg>
                }
            </div>
        }
    </div>
}
